import { Fragment, useEffect } from 'react';
import { Navbar } from 'fileIndexing/otherComponents/Navbar';
import { NavigationMenu } from 'fileIndexing/otherComponents/NavigationMenu';

import { EntitiesTable } from '../components/EntitiesTable';

export function EntitiesMainPage() {
    useEffect(() => {
        document.title = 'File Indexing - Entities';
    }, []);

    return (
        <Fragment>
            <Navbar />
            <NavigationMenu />
            <EntitiesTable />
        </Fragment>
    );
}